import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import {
  OrderSelectedDetailActions,
  RepeatOrderSelectedDetailActionTypes,
} from '@ordersnproducts/modules/new-repeat-order/actions/order-detail.actions';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';

export interface OrderSelectedDetailState {
  loaded: boolean;
  loading: boolean;
  order: Order;
}

export const initialState: OrderSelectedDetailState = {
  loaded: false,
  loading: false,
  order: null,
};

export function reducer(
  state = initialState,
  action: OrderSelectedDetailActions | OrderBuilderActions,
): OrderSelectedDetailState {
  switch (action.type) {
    case RepeatOrderSelectedDetailActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      };
    }
    case RepeatOrderSelectedDetailActionTypes.LOAD_SUCCESS: {
      return {
        ...state,
        loading: false,
        order: {
          ...action.payload['orders'][0],
        },
      };
    }
    case RESET_BUILDER:
    case RepeatOrderSelectedDetailActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case RepeatOrderSelectedDetailActionTypes.RESET_PROGRAMMED_DATE_TIME: {
      return {
        ...state,
        order: {
          ...state.order,
          programmedDateTime: action.payload,
          orderProducts: state.order.orderProducts.map((product) => ({
            ...product,
            programmedDateTime: action.payload,
          })),
        },
      };
    }
    default: {
      return state;
    }
  }
}
